import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useAuth } from "@/hooks/useAuth";
import { LogOut } from "lucide-react";
import { DropDownMenuOrgOption } from "./DropDownMenuOrgOption";
import { DropDownMenuSettingsOption } from "./DropDownMenuSettingsOption";

export function NavUserDropdown() {
  const { user, onLogout } = useAuth();
  const userInitials = (user?.firstName?.charAt(0) ?? "") + (user?.lastName?.charAt(0) ?? "");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Avatar className="size-10 cursor-pointer transition-opacity hover:opacity-80">
          <AvatarImage src={user?.photoURL ?? undefined} alt={user?.firstName ?? "User"} />
          <AvatarFallback className="text-sm font-medium">{userInitials}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        side="bottom"
        align="end"
        className="cursor-pointer !border-gray-200 !bg-white p-0 !text-black shadow-md hover:!bg-white hover:!text-black"
      >
        <DropDownMenuOrgOption />
        <DropdownMenuSeparator className="mx-0 my-0 w-full !bg-gray-200" />
        <DropDownMenuSettingsOption />
        <DropdownMenuSeparator className="mx-0 my-0 w-full !bg-gray-200" />
        <DropdownMenuItem onClick={onLogout} className="flex w-full cursor-pointer items-center gap-2 p-2 hover:!bg-gray-100 hover:!text-black">
          <LogOut className="h-4 w-4 shrink-0" />
          <p className="min-w-0 flex-1 text-left">Log out</p>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
